"use strict";
exports.__esModule = true;
exports.chartjsOptions = void 0;
var dayjs = require("dayjs");
exports.chartjsOptions = {
    responsive: true,
    pointHitRadius: 10,
    pointBorderWidth: 5,
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            enabled: false,
            external: function (context) {
                // Tooltip Element
                var tooltipEl = document.getElementById("chartjs-tooltip");
                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement("div");
                    tooltipEl.id = "chartjs-tooltip";
                    tooltipEl.innerHTML = "<div class='tooltip-wrapper'></div>";
                    document.body.appendChild(tooltipEl);
                }
                // Hide if no tooltip
                var tooltipModel = context.tooltip;
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = "0";
                    return;
                }
                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                }
                else {
                    tooltipEl.classList.add("no-transform");
                }
                function getBody(bodyItem) {
                    return bodyItem.lines;
                }
                // Set Text
                if (tooltipModel.body) {
                    var titleLines = tooltipModel.title || [];
                    var bodyLines = tooltipModel.body.map(getBody);
                    var innerHtml_1 = "";
                    titleLines.forEach(function (title) {
                        innerHtml_1 += "\n            <div class=\"tooltip-inner\">\n              <span class=\"label\">Data</span>\n              <span class=\"value\">".concat(title, "</span>\n            </div>\n            ");
                    });
                    bodyLines.forEach(function (body, i) {
                        var _a;
                        var value = Number(((_a = body[i]) !== null && _a !== void 0 ? _a : 0).replaceAll(',', '.')).toFixed(2);
                        innerHtml_1 += "\n            <div class=\"tooltip-inner\">\n              <span class=\"label\">Valore quota</span>\n              <span class=\"value\">\u20AC".concat(value, "</span>\n            </div>\n            ");
                    });
                    var tableRoot = tooltipEl.querySelector(".tooltip-wrapper");
                    tableRoot.innerHTML = innerHtml_1;
                }
                var position = context.chart.canvas.getBoundingClientRect();
                // Display, position, and set styles for font
                tooltipEl.style.opacity = "1";
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                    position.left + window.pageXOffset + tooltipModel.caretX + "px";
                tooltipEl.style.top =
                    position.top + window.pageYOffset + tooltipModel.caretY + "px";
                tooltipEl.style.font = "";
                tooltipEl.style.padding =
                    tooltipModel.padding + "px " + tooltipModel.padding + "px";
                tooltipEl.style.pointerEvents = "none";
            }
        }
    },
    scales: {
        x: {
            ticks: {
                // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                callback: function (val) {
                    return dayjs(this.getLabelForValue(val)).format("YYYY");
                }
            },
            grid: {
                display: false,
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false
            }
        },
        y: {
            grid: {
                display: false,
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false
            }
        }
    }
};
